.mantine-Tabs-list {
  height: max-content;
}

.mantine-datatable-table th {
  border-top: none !important;
  border-right: none !important;
  border-left: none !important;
  padding: 7px 10px !important;
}

.mantine-Table-td {
  border: none !important;
  padding: 0px var(--mantine-spacing-xs) 0px 0px !important;
  vertical-align: middle !important;
  background-color: transparent !important;
}

.mantine-Tabs-tab {
  background-color: transparent !important;
  color: #000 !important;
}

.mantine-CloseButton-root {
  color: var(--mantine-color-gray-7) !important;
}

.mantine-CloseButton-root:hover {
  background-color: transparent !important;
}

.mantine-Button-root {
  background: var(--button-bg, var(--mantine-primary-color-filled)) !important;
  border: var(
    --button-bd,
    calc(0.0625rem * var(--mantine-scale)) solid transparent
  ) !important;
  color: var(--button-color, var(--mantine-color-white)) !important;
}

/* .mantine-Popover-dropdown {
  /* This fix is needed because Mantine portal are translated up in Elementor */
/*transform: translateY(1.9rem);
} */

.mantine-Accordion-control:hover,
.mantine-Accordion-control:focus {
  color: var(--mantine-color-black);
}

.mantine-UnstyledButton-root[data-variant='subtle']:hover,
.mantine-UnstyledButton-root[data-variant='subtle']:focus {
  color: var(--mantine-color-gray-7);
  background-color: transparent;
}
